/**
 * The quote's Activity tab (walkthrough findings §4, Oct 30) — the shared
 * activity component, as the job and the contact have it: the composer, what
 * is open, then the timeline (`RecordActivityTab`, object `quote`). Above it,
 * the customer's unhandled responses, which `docs/proposal.md` §10.3 puts on
 * this tab as well as the rail — the same card, `FromTheCustomer`, drawn only
 * when there is something to read.
 */
import { useCallback, useEffect, useState } from 'react'
import { request } from '../lib/api.js'
import { completeActivity, type RecordActivity } from '../lib/use-record.js'
import { RecordActivityTab } from '../record/record-activity.js'
import { FromTheCustomer } from './proposal-tab.js'

export function QuoteActivity({ quoteId, canEdit, phone }: { quoteId: string; canEdit: boolean; phone: boolean }) {
  const [people, setPeople] = useState<{ id: string; name: string }[]>([])
  const [upcoming, setUpcoming] = useState<RecordActivity[]>([])
  const [busyId, setBusyId] = useState<string | null>(null)

  useEffect(() => {
    void request<{ items: { id: string; name: string }[] }>('/people?limit=200')
      .then((body) => setPeople(body.items))
      .catch(() => setPeople([]))
  }, [])

  const readUpcoming = useCallback(() => {
    void request<{ items: RecordActivity[] }>(`/records/quote/${encodeURIComponent(quoteId)}/upcoming`)
      .then((body) => setUpcoming(body.items))
      .catch(() => setUpcoming([]))
  }, [quoteId])
  useEffect(() => { readUpcoming() }, [readUpcoming])

  return (
    <div className={phone ? 'flex-1 bg-bg px-4 pb-[190px] pt-3' : 'flex-1 bg-bg px-6 py-5'}>
      <div className="flex max-w-[880px] flex-col gap-3.5">
        <FromTheCustomer quoteId={quoteId} canEdit={canEdit} />
        <RecordActivityTab
          object="quote"
          id={quoteId}
          people={people}
          upcoming={upcoming}
          busyId={busyId}
          onComplete={(activityId) => {
            setBusyId(activityId)
            void completeActivity(activityId).finally(() => { setBusyId(null); readUpcoming() })
          }}
          onChanged={readUpcoming}
        />
      </div>
    </div>
  )
}
